class ScrollDown {
  constructor(btnScrollDown) {
    this.el = btnScrollDown;
    this.offset = 0;
    this.checkWindowSize();
    this.bindListeners();
  }

  bindListeners() {
    this.el.addEventListener("click", this.scroll.bind(this));
    window.addEventListener('resize', this.checkWindowSize.bind(this));
  }

  checkWindowSize() {
    if (window.innerWidth > 1023) {
      this.offset = 76;
    } else {
      if (this.el.classList.contains('home')) {
        this.offset = 76;
      } else {
        this.offset = 0;
      } 
    }
  }

  scroll() {
    console.log('click');
    const targetSection = document.querySelector('[id*="anchor"]');
    console.log(targetSection);

    if (targetSection) {
      const position = targetSection.offsetTop - this.offset;
      window.scrollTo({
        top: position,
        behavior: "smooth"
      });
    }
  }
}

function initScrollBtn() {
  const btnsScrollDown = document.querySelectorAll("#js-scroll-down");

  btnsScrollDown.forEach((btn) => {
    if (btn) {
      new ScrollDown(btn);
    }
  });
}


initScrollBtn();
